import styled from "@emotion/styled"

const FooterOfficeText = styled.span`
  display: inline-block;
  font-size: 18px;
  line-height: 1.7;
  color: ${({ theme }) => theme.palette.gray["600"]};
  text-decoration: none;
`

export default FooterOfficeText
